module.exports = __webpack_public_path__ + "img/productRobot_21.16c50084.png";